import type { TGetProdutosResponse } from '@/features/produtos/interfaces/produto.types'
import type { TUnidadeTipoEnum } from '@/shared/interfaces/produto.enums'
import { HttpService } from '@/shared/lib/http'

export class GetProdutosService extends HttpService {
  execute = async (idExternoBloco: number, tipoDoProduto: TUnidadeTipoEnum, isVagaPadrao = false) => {
    return this.http.get<TGetProdutosResponse>(
      `/api/v2/Produto/bloco/${idExternoBloco}/tipoProduto/${tipoDoProduto}?vagasPadrao=${isVagaPadrao}`,
    )
  }
}
